<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title> 
                <v-btn icon href="/trigger-mail-template">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>       
                {{ 'Triggered Email Template' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="9" md="9">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Template name' | translate"
                            v-model="template_name"
                            name="template_name"
                            autocomplete="off"
                            :rules="templatenameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                    v-model="sendGroup"
                                    :items="recipientType"
                                    item-value="value"
                                    item-text="text"
                                    :label="'Select Recipient Type' | translate"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    @change="getRecipients()"
                                    :rules="recipientRules"
                                    :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-if="sendGroup=='group'">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                v-model="userGroupList"
                                :items="groups"
                                item-value="group_id"
                                :item-text="item =>`${item.group_name}`"
                                :label="'User Group' | translate"
                                outlined
                                chips
                                small-chips
                                multiple
                                required
                                :no-data-text="$t('No data available')"
                                >
                                <template #message="{ message }">
                                {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>  
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row v-if="sendGroup=='users'">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                v-model="userList"
                                :items="users"
                                item-value="user_id"
                                :item-text="item =>`${item.name} (${item.email})`"
                                :label="'Users' | translate"
                                outlined
                                chips
                                small-chips
                                multiple
                                required
                                :no-data-text="$t('No data available')"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                           
                        <v-row>
                            <v-col cols="12" sm="12">
                                <h3>{{"Trigger Email Event Settings" | translate}}</h3>
                                <v-row>
                                <v-col cols="12" md="12" sm="12">
                                  <v-autocomplete
                                    v-model="trigger_event"
                                    :items="triggeremailtypes"
                                    :label="'Trigger Event' | translate"
                                    outlined
                                    chips
                                    small-chips
                                    required
                                    :disabled="(template_id? true : false)"
                                    :no-data-text="$t('No data available')"
                                    @change="triggerEmailTypeSelected"
                                  >
                                  <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>  
                                  </v-autocomplete>
                                </v-col>
                                </v-row>

                                <v-row>
                                <v-col cols="12" md="4" sm="4">
                                    <v-text-field 
                                        v-model="trigger_due_days"
                                        :label="'Due Days' | translate"
                                        outlined
                                        type="number"
                                        autocomplete="off"
                                        required
                                        min="1"
                                        @keyup="resetDueDays()"
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                    <p class="mt-n3">
                                        {{"Add Due Days Count, Email will be sent Due days Before Due Date." | translate}}
                                    </p> 
                                </v-col>
                                <v-col cols="12" md="3" sm="3">
                                 <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="trigger_time"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="trigger_time"
                                      :label="'Trigger Time' | translate"
                                      prepend-icon="mdi-clock-time-four-outline"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-time-picker
                                    v-if="menu2"
                                    v-model="trigger_time"
                                    full-width
                                    @click:minute="$refs.menu2.save(trigger_time)"
                                  ></v-time-picker>
                                </v-menu>
                              </v-col>

                              <v-col cols="12" md="4" sm="4">
                                <span class="v-input mt-6">{{"Timezone" | translate}} ({{timezone | translate}})</span>
                              </v-col>

                              </v-row>

                                <v-row>
                                     <v-switch
                                    v-model="campaignswitch"
                                    :label="`Campaign? ${campaignLabel}` | translate"
                                    :disabled="(template_id? true : false)"
                                    ></v-switch>
                                </v-row>
                            </v-col>
                        </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12" class="mt-n3 pb-4">
                          <h3>{{'Placeholders' | translate}}</h3>
                            <span class="pa-2" v-if="trigger_event.length"> {{"Use these placeholders while constructing Email" | translate}} </span>
                            <span class="pa-2" v-else> {{"No placeholders available" | translate}} </span>
                            <div>
                                <v-chip
                                class="ma-2 mb-4"  v-for='(placeholders,index) in tmailplaceholders' :key='index'
                                @click="addplaceholder(placeholders)"
                                >
                                {{placeholders}}
                                </v-chip>
                                <span id="custom-tooltip">{{"Copied to Clipboard!" | translate}} </span>
                            </div>
                        </v-col>
                      </v-row>

                      <div v-if="missing_fields_error_message" class="v-messages theme--light error--text" role="alert">
                        <div class="v-messages__wrapper">
                          <div class="v-messages__message">
                                      {{missing_fields_error_message}}
                          </div>
                        </div>
                      </div>

                      <v-tabs v-if="!campaignswitch"
                      v-model="tabs"
                      >
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab  
                          v-for="language in availablelanguages" :key="language.lang_id" 
                          :href="'#'+language.lang_code">
                          <span v-if="company_default_language===language.lang_code" 
                          style="color: #dc3545!important;">*</span>
                            {{ language.lang_name | translate}} 
                        </v-tab>
                      </v-tabs>
            
                      <v-tabs-items v-model="tabs" v-if="!campaignswitch">
                          <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field
                                  outlined
                                  :label="'Subject in ' +language.lang_name| translate"
                                  v-model="template_subject[index]"
                                  name="subject"
                                  autocomplete="off"
                                  required
                                >
                                <template #message="{ message }">
                                  {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                </template>                            
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="12">
                                
                                <div class="mb-3 mt-n2 pb-6"> <span class="title">{{"Email in " +language.lang_name| translate}}</span>
                                  <div class="d-flex test-mail-section">
                                      <div class="d-flex test-mail-input" v-if="test_mail_input">
                                        <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                        <v-btn
                                          elevation="2"
                                          small
                                          class="white--text mt-1" :color="primary_color"
                                          @click="sendTestMail(language, trigger_due_days)"
                                        > 
                                        <v-progress-circular
                                          indeterminate
                                          :size="20"
                                          :width="2"
                                          color="white"
                                          v-if="sendingTestMailInProgress"
                                        ></v-progress-circular>
                                        {{"Send" | translate}} </v-btn>
                                      </div>
                                      <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                          <v-btn
                                            elevation="2"
                                            small
                                            class="white--text btn" :color="primary_color"
                                            v-if="template_id && templateEdited"
                                            @click="toggleMailInput"
                                          > {{"Send Test Mail" | translate}}</v-btn>
                                      </div>
                                  </div>
                                  
                                </div>
                                  
                                  <template>
                                      <div id="app">
                                          <tiptap 
                                          v-model="template[index]"
                                          />
                                      </div>
                                  </template>

                              </v-col>
                            </v-row>
                          </v-tab-item>    
                      </v-tabs-items>  

                       <v-card outlined class="mt-6 pa-3" v-for="(emailtemplate,i) in emailtemplates" :key="i">
                            <v-row>
                              <v-col cols="4" md="4" sm="4">
                                    <v-text-field 
                                        v-model="emailtemplates[i]['trigger_due_days']"
                                        :label="campaignTypeLabel(i)"
                                        outlined
                                        type="number"
                                        autocomplete="off"
                                        required
                                        min="1"
                                        :disabled="!i"
                                        @change="validateextrafields(i)"
                                    >
                                    <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                            
                                    </v-text-field>
                                    <div v-if="due_date_error_message.length" class="v-messages theme--light error--text" role="alert">
                                      <div class="v-messages__wrapper">
                                        <div class="v-messages__message">
                                            {{due_date_error_message[i]}}
                                        </div>
                                      </div>
                                    </div>
                                </v-col>

                                 <v-col cols="7" md="7" sm="7" v-if="i">
                                  <span class="v-input mt-6">{{"Days" | translate}}</span>
                                </v-col>

                                <v-col cols="1" sm="1" md="1">
                                  <v-icon :disabled="!i" class="mr-2" v-on:click="handleDelete(i)" >delete</v-icon>
                                </v-col>

                            </v-row>

                            <v-col cols="12" sm="12" md="12" class="mt-n6">
                                <v-tabs
                                    v-model="campaigntabs[i]"
                                >
                                    <v-tabs-slider></v-tabs-slider>
                                    <v-tab  
                                    v-for="language in availablelanguages" :key="language.lang_id" 
                                    :href="'#'+language.lang_code">
                                    <span v-if="company_default_language===language.lang_code" 
                                    style="color: #dc3545!important;">*</span>
                                        {{ language.lang_name | translate}} 
                                    </v-tab>
                                </v-tabs>
                    
                                <v-tabs-items v-model="campaigntabs[i]">
                                    <v-tab-item class="mt-4" v-for="(language, index) in availablelanguages" :key="index" v-bind:value="language.lang_code">
                                      
                                        <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-text-field
                                            outlined
                                            :label="'Subject in ' +language.lang_name| translate"
                                            v-model="emailtemplates[i]['template_subject'][index]"
                                            name="subject"
                                            autocomplete="off"
                                            required
                                            >
                                            <template #message="{ message }">
                                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                            </template>                            
                                            </v-text-field>
                                        </v-col>
                                        </v-row>

                                        <v-row>
                                        <v-col cols="12" sm="12">
                                            
                                            <div class="mb-3 mt-n2 pb-6"> <span class="title">{{"Email in " +language.lang_name| translate}}</span>
                                            <div class="d-flex test-mail-section">
                                                <div class="d-flex test-mail-input" v-if="test_mail_input">
                                                    <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                                    <v-btn
                                                    elevation="2"
                                                    small
                                                    class="white--text mt-1" :color="primary_color"
                                                    @click="sendTestMail(language,emailtemplates[i]['trigger_due_days'])"
                                                    > 
                                                    <v-progress-circular
                                                      indeterminate
                                                      :size="20"
                                                      :width="2"
                                                      color="white"
                                                      v-if="sendingTestMailInProgress"
                                                    ></v-progress-circular>
                                                    {{"Send" | translate}} </v-btn>
                                                </div>
                                                <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                                    <v-btn
                                                        elevation="2"
                                                        small
                                                        class="white--text btn" :color="primary_color"
                                                        v-if="template_id"
                                                        @click="toggleMailInput"
                                                    > {{"Send Test Mail" | translate}}</v-btn>
                                                </div>
                                            </div>
                                            
                                            </div>
                                            
                                            <template>
                                                <div id="app">
                                                    <tiptap 
                                                    v-model="emailtemplates[i]['template'][index]"
                                                    />
                                                </div>
                                            </template>

                                        </v-col>
                                        </v-row>
                                    </v-tab-item>    
                                </v-tabs-items>  
                            </v-col>
                      </v-card>

                       <v-row>
                            <v-col cols="12">
                                <v-card-text class="pb-4 title" v-if="canAddTemplate" @click="addTemplate" style="cursor: pointer" >{{ 'Add Template' | translate}}
                                <v-icon >mdi-plus-box</v-icon>
                                </v-card-text>   
                            </v-col>
                        </v-row>
                      

                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>

                          
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  FETCH_LANGUAGES,
  FETCH_INDIVIDUAL_TRIGGERED_MAIL_TEMPLATE,
  SEND_TRIGGERED_TEST_MAIL, 
  ADD_TRIGGERED_MAIL_TEMPLATE,
  UPDATE_TRIGGERED_MAIL_TEMPLATE,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_COMPANY_SETTINGS,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import tiptap from '@/components/tiptap/tiptap.vue'
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addcustomemailtemplate",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE)
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
        await store.dispatch(FETCH_LANGUAGES, ""),
        await store.dispatch(FETCH_COMPANY_SETTINGS, 'profile'),
    ]).then(() => {
        store.commit(SET_LOADING, false)
      }) 
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_TRIGGERED_MAIL_TEMPLATE, to.params.id)
    }

    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  components: { tiptap }, 
  computed: {
    ...mapGetters(['adminusers','languages', 'tindividualtemplate', 'currentUser', 'curLanguage', 'companysettings']),
    ...mapState({
      errors: state => state.groups.grouperrors,
    }),
    templatenameRules(){  return [v => !!v || "Template name is required"]},
    recipientRules(){  return [v => !!v || "Recipient is required"]},
    emailRules(){ 
      return [v => /.+@.+/.test(v) || this.$t("Invalid Email address")]
    },
    recipientType(){
      return [
          {value: 'group', text:this.$t('Group')},
          {value: 'users', text:this.$t('Users')},
          {value: 'all_users', text:this.$t('All Users')}
      ]
    },
    triggeremailtypes(){
      return [
          {value: 'inbox_document', text:this.$t('Inbox Documents'), placeholders:['{{userEmail}}','{{userName}}','{{documentName}}', '{{documentType}}', '{{dueDate}}']},
          {value: 'course', text:this.$t('Course Subscriptions Ending'), placeholders:['{{userEmail}}','{{userName}}','{{courseName}}', '{{courseEndsOn}}']},
      ]
    },
    isUser(){
      //User can be company admin as well, in this case role of company admin supersedes that of user
      if(this.currentUser.roles.includes(1)){
        return false;
      }
      return this.currentUser.roles.includes(4) 
    }, 
    canAddTemplate(){
        if(this.campaignswitch && !this.reachedMaxTemplateCount){
            return true;
        }
        return false;
    },
    availablelanguages(){
      let availablelanguages=[];

      let selectedLang = this.languages.filter(data =>data.lang_code == this.company_default_language)
      selectedLang.forEach((lang) => {
        availablelanguages.push(lang);
      });
      
      let otherlang = this.languages.filter(data =>data.lang_code != this.company_default_language)
      otherlang.forEach((lang) => {
        availablelanguages.push(lang);
      });
      return availablelanguages;
    },
    campaignLabel(){
        return this.campaignswitch?'Yes':'No';
    }
   

  },
  async mounted () {
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }

    this.test_email = this.currentUser.email;
    this.templateEdited = true;
    this.companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = this.companymeta.primary_color 
    this.company_default_language = this.currentUser.company.language.lang_code;
    this.tabs = this.currentUser.company.language.lang_code;
    if(this.companysettings.hasOwnProperty('setting_data')){
      this.timezone = this.companysettings.setting_data.timezone
    }

    if(Object.keys(this.tindividualtemplate).length >0){
      this.template_id = this.tindividualtemplate.tg_temp_id
      this.template_name =   this.tindividualtemplate.trigger_template_name
      this.trigger_event   =   this.tindividualtemplate.trigger_event
      this.trigger_due_days   =   this.tindividualtemplate.trigger_due_days
      this.trigger_time   =   this.tindividualtemplate.trigger_time
      
      if(this.tindividualtemplate.groups.length){
        this.sendGroup='group';
        await this.getRecipients();
        this.userGroupList = this.tindividualtemplate.groups;
      }
      else if(this.tindividualtemplate.users.length){
        this.sendGroup='users';
        await this.getRecipients();
        this.userList = this.tindividualtemplate.users
      }

      let last_due_date = this.tindividualtemplate.trigger_mail_template_messages[this.tindividualtemplate.trigger_mail_template_messages.length-1].on_due_day ;
      if(last_due_date != this.trigger_due_days){
        this.campaignswitch = true;
      }

      if(this.campaignswitch){
        //initialize array with on_due_day values
          var on_due_day = 0;
          let iterator = 0;
          let last_actual_trigger_due_days = this.trigger_due_days; // initialization to last count
          this.tindividualtemplate.trigger_mail_template_messages.forEach((item1) => {
              on_due_day = item1.on_due_day;
            const found = (this.emailtemplates).some(el => el.actual_trigger_due_days === on_due_day);
            if(on_due_day==item1.on_due_day && !found){
              iterator = iterator + 1;
              
              this.emailtemplates.push({ 
                  element_count: iterator,
                  trigger_due_days : (iterator==1) ? item1.on_due_day :  last_actual_trigger_due_days - item1.on_due_day,
                  actual_trigger_due_days : item1.on_due_day,
                  template_subject : [],
                  template : [],
              });
              last_actual_trigger_due_days = item1.on_due_day; // keep track of the last due day
            }
          }); 

          this.tindividualtemplate.trigger_mail_template_messages.forEach((item1) => {
              this.template_subject = [];
              this.template = [];
              this.availablelanguages.forEach((lang, index) => {
                this.tindividualtemplate.trigger_mail_template_messages.forEach((item2) => {
                  if(lang.lang_code === item2.lang_code && item1.on_due_day === item2.on_due_day){
                      this.$set(this.template_subject, index , item2.subject);
                      this.$set(this.template, index , item2.body) 
                  }
                });
            });

            var elementindex = this.emailtemplates.findIndex(item => item.actual_trigger_due_days==item1.on_due_day);
            this.emailtemplates[elementindex].template_subject = this.template_subject;
            this.emailtemplates[elementindex].template = this.template;

          });
      }
      else{
        this.availablelanguages.forEach((lang,index) => {
            this.tindividualtemplate.trigger_mail_template_messages.forEach((item) => {
            if(lang.lang_code === item.lang_code){
                this.$set(this.template_subject, index , item.subject);
                this.$set(this.template, index , item.body) 
            }
            });
        });
      }

     
     // if(last_due_date!=this.trigger_due_days){
      // let iterator = 0;
      // let on_due_day = 0;
      // this.tindividualtemplate.trigger_mail_template_messages.forEach((item, i) => {
      //     if(on_due_day == 0){
      //       //first element
      //         on_due_day = item.on_due_day;
      //         iterator= iterator+1;

      //         this.template_subject.push(item.subject);
      //         this.template.push(item.body);
          
      //     }
      //     else if( (on_due_day != item.on_due_day)){
      //         this.emailtemplates.push({ 
      //             element_count: iterator,
      //             trigger_due_days : ( on_due_day == this.trigger_due_days ? on_due_day: (on_due_day - item.on_due_day)),
      //             actual_trigger_due_days : (this.tindividualtemplate.trigger_mail_template_messages[i-1].on_due_day),
      //             template_subject : this.template_subject,
      //             template : this.template,
      //         }) 

      //         this.template_subject=[];
      //         this.template=[];

      //         on_due_day = item.on_due_day;
      //         iterator= iterator+1;

      //         this.template_subject.push(item.subject);
      //         this.template.push(item.body);

      //         if(item.on_due_day!= this.trigger_due_days){
      //             this.campaignswitch = true;
      //         }

      //         if(i == this.tindividualtemplate.trigger_mail_template_messages.length-1){
      //             //pushing when we reach last
      //             this.emailtemplates.push({ 
      //                 element_count: iterator,
      //                 trigger_due_days : ( on_due_day == this.trigger_due_days ? on_due_day: (on_due_day - item.on_due_day)),
      //                 actual_trigger_due_days : (this.tindividualtemplate.trigger_mail_template_messages[i-1].on_due_day),
      //                 template_subject : this.template_subject,
      //                 template : this.template,
      //             }) 
      //         }
      //     }
      //     else{
          
      //         this.template_subject.push(item.subject);
      //         this.template.push(item.body);

      //         if(i == this.tindividualtemplate.trigger_mail_template_messages.length-1){
      //             //pushing when we reach last
      //             this.emailtemplates.push({ 
      //                 element_count: iterator,
      //                 trigger_due_days : ( on_due_day == this.trigger_due_days ? on_due_day: (on_due_day - item.on_due_day)),
      //                 actual_trigger_due_days : (this.tindividualtemplate.trigger_mail_template_messages[i-1].on_due_day),
      //                 template_subject : this.template_subject,
      //                 template : this.template,
      //             }) 
      //         }
      //     }
      // });
      // }
      // else{
      //   this.availablelanguages.forEach((lang,index) => {
      //     this.tindividualtemplate.trigger_mail_template_messages.forEach((item) => {
      //       if(lang.lang_code === item.lang_code){
      //         this.$set(this.template_subject, index , item.subject);
      //         this.$set(this.template, index , item.body) 
      //       }
      //     });
      //   });
      // }

      if( this.tindividualtemplate.trigger_event){
        //load the necessary apis to load the placeholders
        this.triggerEmailTypeSelected();
      }

    }
  },
  data: function() {
    return {
      template_id: null,
      template_name: null,
      template_language :null,
      isLoading:false,
      primary_color:null,
      test_mail:true,
      test_mail_input:false,
      test_email:null,
      templateEdited:false,
      trigger_event:[],
      tmailplaceholders:[],

      template_subject: [],
      template: [],
      trigger_mail_template_messages:[],
      company_default_language:null,

      sendGroup: false,
      users:[],
      groups:[],
      userList:[],
      checkAllUsers: false,
      userGroupList:[],
      frequency:null,
      menu: false,
      trigger_due_days: 1,
      trigger_time: "00:00",
      userEmail:"{{userEmail}}",
      userName:"{{userName}}",
      menu2: false,
      tabs:null,
      timezone:null,
      missing_fields_error_message:'',

      campaignswitch:false,
      emailtemplates:[],
      campaigntabs:[],
      due_date_error_message: [],
      reachedMaxTemplateCount: false,
      sendingTestMailInProgress: false,

    }
  },
  watch: {
    // whenever template changes, this function will run
    template(newValue, oldValue) {
      if(oldValue){
        if(newValue !== oldValue){
          this.templateEdited = false;
        }
      }
    },
    campaignswitch(){
        if(this.emailtemplates.length==0){
            this.emailtemplates.push({ 
                element_count: this.emailtemplates.length+1,
                trigger_due_days : this.trigger_due_days,
                actual_trigger_due_days : this.trigger_due_days,
                template_subject : [],
                template : [],
            })
        }
    }
  },
  methods : {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('has-access-to-trigger-mails') ){
        return true;
      }
      return false;
    },
    addTemplate () {
        if(this.emailtemplates.length==5){
            alert("You cannot add more than 5 templates");
            return;
        }
        this.emailtemplates.push({ 
          element_count: this.emailtemplates.length+1,
          trigger_due_days : 1,
          actual_trigger_due_days : 1,
          template_subject : [],
          template : [],
        })
        this.recalculateActualDueDays((this.emailtemplates.length)-1)
    },
    campaignTypeLabel(index){
        return index ? this.$t('Send After'):this.$t('Due Days');
    },
    validateextrafields(index){
      this.due_date_error_message[index]=null;
        if(parseInt(this.emailtemplates[index]['trigger_due_days']) < 1 ){
            this.emailtemplates[index]['trigger_due_days'] = '';
            this.due_date_error_message[index] = "Invalid day count. Enter a value greater than or equal to 1";
            return;
        }
        this.reachedMaxTemplateCount = false;
        this.recalculateActualDueDays(index);
    },
    recalculateActualDueDays(index){
      this.emailtemplates[index]['actual_trigger_due_days'] = parseInt(this.emailtemplates[index-1]['actual_trigger_due_days']) - parseInt(this.emailtemplates[index]['trigger_due_days']) ;
    },
    recalculateAllActualDueDays(){
      this.emailtemplates.forEach((et, index) => {
        if(index){
          this.emailtemplates[index]['actual_trigger_due_days'] = parseInt(this.emailtemplates[index-1]['actual_trigger_due_days']) - parseInt(this.emailtemplates[index]['trigger_due_days']);
        }
      });
    },
    resetDueDays(){
      if(this.campaignswitch){
      this.emailtemplates[0]['trigger_due_days'] = this.trigger_due_days;
      this.emailtemplates[0]['actual_trigger_due_days'] = this.trigger_due_days;
      this.recalculateAllActualDueDays();
      }
    },
    async getRecipients(){
        if(this.sendGroup=='users'){
            await this.$store.dispatch(FETCH_USERS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.users = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
            });
        }
        else{
            await this.$store.dispatch(FETCH_GROUPS, '').then(resp => {
                if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
                    this.$store.commit(SET_LOADING, false);
                    this.groups = resp.data;
                }
                else{
                    this.$store.commit(SET_LOADING, false);
                }
            });
        }
    },
    checkboxUpdated(flag){
      if(flag == "users" && this.checkAllUsers){
        this.userList = []
        this.userList = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.userList = []
      }

    },
    triggerEmailTypeSelected() {
      if(this.trigger_event){
        //fetch related placeholders
        let emailType = (this.triggeremailtypes.filter(data => data.value == this.trigger_event)[0]);
        this.tmailplaceholders = emailType.placeholders;
      }
    },
    toggleMailInput(){
      this.test_mail = false;
      this.test_mail_input = true;
    },
    sendTestMail(lang, on_due_day){
      if (this.$refs.form.validate()) {
        this.sendingTestMailInProgress = true;
        let data = {
            email: this.test_email,
            lang_code: lang.lang_code,
            on_due_day: (on_due_day==this.trigger_due_days)? on_due_day : (this.trigger_due_days - on_due_day),
            tg_temp_id:this.template_id
          }

        this.$store
          .dispatch(SEND_TRIGGERED_TEST_MAIL, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Mail Sent! Please check email'})
              store.commit(SET_LOADING, false)
              this.test_mail = true;
              this.test_mail_input = false;
              this.sendingTestMailInProgress = false;
            }
            else{
              store.commit(SET_LOADING, false)
              this.sendingTestMailInProgress = false;
            }
          });
      }
    },
    addplaceholder(placeholder) {
        const insertText = placeholder
        if (!insertText.length) return

        navigator.clipboard.writeText(placeholder).then(() => {
          /* clipboard successfully set */
          document.getElementById("custom-tooltip").style.display = "inline";
          setTimeout( function() {
              document.getElementById("custom-tooltip").style.display = "none";
          }, 1000);
        }, () => {
          /* clipboard write failed */
        });
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            trigger_template_name: this.template_name,
            recipient_type:this.sendGroup,
            trigger_event: this.trigger_event,
            trigger_due_days: this.trigger_due_days,
            trigger_time:this.trigger_time,
          }

          if(this.sendGroup=='group'){
            data["groups"] = this.userGroupList;
          }
          else if(this.sendGroup=='users'){
            data["users"] = this.userList;
          }
          else if(this.sendGroup=='all_users'){
            data["all_users"] = true;
          }

          if(this.campaignswitch){
            this.emailtemplates.forEach((et) => {
                this.availablelanguages.forEach((lang,index) => {
                    if(et.template_subject[index]!=""){
                        if(et.template_subject[index]!=null){
                            this.trigger_mail_template_messages.push({
                                "on_due_day": et.actual_trigger_due_days,
                                "lang_code": lang.lang_code,
                                "subject": et.template_subject[index],
                                "body": et.template[index]
                            });
                        }
                    }
                });
            });
        }
        else{
          this.availablelanguages.forEach((lang,index) => {
            if(this.template_subject[index]!=""){
              if(this.template_subject[index]!=null){
                this.trigger_mail_template_messages.push({
                    "on_due_day": this.trigger_due_days,
                    "lang_code": lang.lang_code,
                    "subject": this.template_subject[index],
                    "body": this.template[index],
                })
              }
            }
          });
        }

          data["trigger_mail_template_messages"] = this.trigger_mail_template_messages;

          if(data["trigger_mail_template_messages"].length==0){
            this.missing_fields_error_message = "You need to fill the at least one language, Email Subject and Email Body";
            return;
          }
        
        this.$store
          .dispatch(ADD_TRIGGERED_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Notification Template created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push("/trigger-mail-template/edit/" + resp.data.tg_temp_id)
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {

        let data = {
            id: this.template_id,
            trigger_template_name: this.template_name,
            recipient_type:this.sendGroup,
            trigger_event: this.trigger_event,
            trigger_due_days:this.trigger_due_days,
            trigger_time:this.trigger_time,
            _method: "put"
          };
          if(this.sendGroup=='group'){
            data["groups"] = this.userGroupList;
          }
          else if(this.sendGroup=='users'){
            data["users"] = this.userList;
          }
          else if(this.sendGroup=='all_users'){
            data["all_users"] = true;
          }

          this.trigger_mail_template_messages =[];
          
          if(this.campaignswitch){
            this.emailtemplates.forEach((et) => {
                this.availablelanguages.forEach((lang,index) => {
                    if(et.template_subject[index]!=""){
                        if(et.template_subject[index]!=null){
                          this.trigger_mail_template_messages.push({
                              "on_due_day": et.actual_trigger_due_days,
                              "lang_code": lang.lang_code,
                              "subject": et.template_subject[index],
                              "body": et.template[index]
                          });
                        }
                    }
                });
            });
          }
          else{
            this.availablelanguages.forEach((lang,index) => {
              if(this.template_subject[index]!=""){
                if(this.template_subject[index]!=null){
                  this.trigger_mail_template_messages.push({
                    "on_due_day": this.trigger_due_days,
                    "lang_code": lang.lang_code,
                    "subject": this.template_subject[index],
                    "body": this.template[index],
                  })
                }
              }
            });
          }
          data["trigger_mail_template_messages"] = this.trigger_mail_template_messages;
          
          if(data["trigger_mail_template_messages"].length==0){
             this.missing_fields_error_message = "You need to fill the at least one language, Email Subject and Email Body";
            return;
          }

        this.$store
          .dispatch(UPDATE_TRIGGERED_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Email Notification successfully Updated'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "triggeredmail" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    handleDelete(index){
      if(this.campaignswitch){
        this.emailtemplates.splice(index, 1);
      }
    }

  },
};
</script>

<style scoped>
[contenteditable] {
  outline: 0px solid transparent;
}

.btn.disabled {
    pointer-events: auto;
}

.test-mail-section{
  float: right;
}
#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
    background-color: #000000df;
    border-radius: 4px;
    color: #fff;
}
</style>